import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  className,
  label,
  ...props
}, ref) => {
  return <label className="flex items-start space-x-2 cursor-pointer group" data-id="element-308">
        <input type="checkbox" className={cn('mt-1 h-4 w-4 rounded border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-indigo-600 dark:text-indigo-500 focus:ring-indigo-500 dark:focus:ring-indigo-400 transition-colors', className)} ref={ref} {...props} data-id="element-309" />
        <span className="text-sm text-slate-700 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-slate-100 leading-snug" data-id="element-310">
          {label}
        </span>
      </label>;
});
Checkbox.displayName = 'Checkbox';